import { QueryClientProvider } from '@tanstack/react-query';
// import * as Sentry from '@sentry/react';
// import { SENTRY_DSN } from './config/app.ts';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen.ts';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './context/theme-context.tsx';
import { FontProvider } from './context/font-context.tsx';
import './i18n/config.ts';
import queryClient from './queries/queryClient.ts';
import { SENTRY_DSN } from './config/app.ts';
import * as Sentry from '@sentry/react';

// if (process.env.NODE_ENV === 'production') {
Sentry.init({
  dsn: SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [],
});
// }

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
const rootElement = document.getElementById('root')!;
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <FontProvider>
          <RouterProvider router={router} />
        </FontProvider>
      </ThemeProvider>
    </QueryClientProvider>,
  );
}
